module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold.11ec013.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NotoSansKR-Bold.woff
// module id = 7EjT
// module chunks = 1